import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// import './instrument'

import App from "./App";
import { GlobalStateProvider } from "./providers/GlobalStateProvider";

const init = (config) => {
  if (!config) return;
  const root = createRoot(document.getElementById("nut-widget-container")!);
  root.render(
    <StrictMode>
      <GlobalStateProvider>
        <App storeUrl={config.storeUrl} />
      </GlobalStateProvider>
    </StrictMode>,
  );
};
window.nutInit = init;
export default init;
